import React from 'react';
import classNames from 'classnames';

import {SCHEDULE_ITEM_TYPES} from 'ducks/tenancy';

import {formatDate} from 'utils/datetime';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import Ellipsis from 'components/Ellipsis';
import PaymentStatusTag from 'components/PaymentStatusTag';

import {getSyncedWithXeroIcon} from 'containers/BookingDetail/utils';

const OverpaymentRow = ({overpayment, scheduleType, handleRowClick}) => {
  const {overpaymentDetails} = overpayment;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: overpayment.highlighted
      })}
      onClick={() =>
        handleRowClick(
          SCHEDULE_ITEM_TYPES.OVERPAYMENT,
          overpayment.id,
          scheduleType
        )
      }>
      <Table.Cell>{formatDate(overpayment.date)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="activity">
        <div className="colab-centered">
          {overpaymentDetails.hasXeroErrors && <Alert />}
          <Ellipsis>{overpayment.activity}</Ellipsis>
        </div>
      </Table.Cell>
      <Table.Cell className="details">
        <Ellipsis>{overpaymentDetails.description}</Ellipsis>
      </Table.Cell>
      <Table.Cell>
        {overpaymentDetails.voided && (
          <PaymentStatusTag status={PaymentStatusTag.VOIDED} />
        )}
      </Table.Cell>
      <Table.Cell>
        {getSyncedWithXeroIcon(overpaymentDetails.xeroId)}
      </Table.Cell>
      <Table.Cell />
      <Table.Cell className="payment">
        <Money
          amount={overpayment.amount}
          balance
          className={classNames({
            strikeThrough: overpaymentDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell className="balance">
        <Money amount={overpayment.balance} balance />
      </Table.Cell>
    </Table.Row>
  );
};

export default OverpaymentRow;
